import LoadingSpinner from '$tablet-app/src/app/components/LoadingSpinner';
import Spacer from '$tablet-app/src/app/components/Spacer';
import { Button } from '@akin-home/buttons/native';
import { DashboardTemplate } from '@akin-home/dashboards';
import { Text } from '@akin-home/text/native';
import { spacing } from '@akin-home/theme';
import { ScrollView, StyleSheet, View } from 'react-native';
import { DashboardSelectionItem } from './components/DashboardSelectionItem';

type Props = {
  saving?: boolean;
  selected_dashboard_id?: string;
  dashboard_options: DashboardTemplate[];

  onPressDashboard(dashboard_id: string): void;
  onPressContinue(): void;
  onPressCustomize(): void;
};

export function ChooseHomeScreenView(props: Props) {
  return (
    <View style={styles.container}>
      <View style={styles.topContainer}>
        <Text style={styles.centeredText} variant="h1" weight="semibold">
          Choose your home screen look
        </Text>

        <Text style={styles.centeredText}>
          Choose the layout that suits your style and needs. Select from our
          three curated options below:
        </Text>
      </View>

      <Spacer flex={1} />

      <ScrollView
        style={styles.scrollView}
        contentContainerStyle={styles.scrollViewContentContainer}
      >
        {props.dashboard_options.map((option, idx) => (
          <DashboardSelectionItem
            key={option.id}
            idx={idx}
            template={option}
            selected={props.selected_dashboard_id === option.id}
            onPress={props.onPressDashboard}
          />
        ))}
      </ScrollView>

      <Spacer flex={1} />

      <View style={styles.buttonRow}>
        <Button
          size="large"
          style={styles.secondaryButton}
          variant="secondary"
          onPress={props.onPressCustomize}
        >
          Customize
        </Button>
        <Button
          size="large"
          style={styles.button}
          onPress={props.onPressContinue}
        >
          {props.saving ? (
            <LoadingSpinner color="white" size="large" />
          ) : (
            'Continue'
          )}
        </Button>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: '#f6f7f9',
    padding: 20,
    alignItems: 'center',
  },
  topContainer: {
    maxWidth: 670,
    gap: 16,
    alignItems: 'center',
  },
  centeredText: {
    textAlign: 'center',
  },
  scrollView: {
    marginVertical: spacing[3],
  },
  scrollViewContentContainer: {
    paddingHorizontal: spacing[3],
    gap: spacing[4],
    flexWrap: 'wrap',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
  buttonRow: {
    maxWidth: 800,
    width: '100%',

    paddingHorizontal: spacing[2],
    gap: 16,

    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  button: {
    flex: 1,
  },
  secondaryButton: {
    flex: 1,
    backgroundColor: '#e1e3e7',
  },
});
